import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { gettext } from '@eb/i18n';
import times from 'lodash/times';
import uniqBy from 'lodash/uniqBy';

import OrganizerCard from 'consumer-utils/components/OrganizerCard';

import { getSortedOrganizersByPopularCategories } from '../utils/organizers';

import { BUCKET_CONFIG_PROPTYPE } from '../constants/propTypes';

import LoadingCards, { ORGANIZER_TYPE } from './ConsumerEventCard/LoadingCards';
import ScrollPaneWithControls from './ScrollPaneWithControls';

import './OrganizersBucket.scss';

export default class OrganizersCards extends Component {
    static propTypes = {
        bucketKey: PropTypes.string,
        handlePopOrganizer: PropTypes.func,
        handleFollowOrganizer: PropTypes.func,
        handleViewOrganizer: PropTypes.func,
        trackGAEvent: PropTypes.func,
        bucketLayoutConfig: BUCKET_CONFIG_PROPTYPE,
        isLoading: PropTypes.bool,
        profiles: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.string,
                name: PropTypes.string,
                image: PropTypes.shape({ url: PropTypes.string }),
            }),
        ),
    };

    render() {
        const {
            bucketKey,
            bucketLayoutConfig,
            isLoading,
            profiles,
            handlePopOrganizer,
            handleFollowOrganizer,
            handleViewOrganizer,
            trackGAEvent,
        } = this.props;
        const bucketClassNames =
            (bucketLayoutConfig && bucketLayoutConfig.bucketClassNames) || '';

        let profileCardsComponents = [
            <div
                key="not-enough-content"
                className="eds-text-bl eds-l-pad-hor-8 eds-l-pad-vert-6"
            >
                {gettext('There are no more event organizers in this area.')}
            </div>,
        ];

        const loadingCard = (
            <LoadingCards type={ORGANIZER_TYPE} style="grid" cardCount={1} />
        );

        if (isLoading) {
            profileCardsComponents = times(7, (index) => (
                <div className="eds-l-pad-hor-3" key={`loading-card-${index}`}>
                    {loadingCard}
                </div>
            ));
        }

        const uniqProfiles = uniqBy(profiles, 'id');

        if (uniqProfiles.length) {
            const sortedProfiles = getSortedOrganizersByPopularCategories(
                uniqProfiles,
            );

            profileCardsComponents = sortedProfiles.map(
                ({
                    id: organizerId,
                    name: organizerName,
                    image,
                    sampleEvent,
                    numUpcomingEvents,
                    ...cardProps
                }) => {
                    const organizerImage = image ? image.url : '';

                    let imageUrl = organizerImage;

                    if (!organizerImage && sampleEvent && sampleEvent.image) {
                        imageUrl = sampleEvent.image.url;
                    }

                    let component = (
                        <div className="eds-l-pad-hor-3">{loadingCard}</div>
                    );

                    if (!isLoading) {
                        component = (
                            <OrganizerCard
                                {...cardProps}
                                organizerId={organizerId}
                                organizerName={organizerName}
                                numUpcomingEvents={numUpcomingEvents}
                                handlePopOrganizer={handlePopOrganizer}
                                handleFollowOrganizer={handleFollowOrganizer}
                                handleViewOrganizer={handleViewOrganizer}
                                trackGAEvent={trackGAEvent}
                                label={`${bucketKey}|${organizerName}`}
                                imageUrl={imageUrl}
                                type="grid"
                            />
                        );
                    }

                    return <div key={organizerId}>{component}</div>;
                },
            );
        }

        return (
            <div className={bucketClassNames}>
                <ScrollPaneWithControls
                    arrowsOnTop={true}
                    largeItemStep={3}
                    buttonsShouldBeDisabled={!uniqProfiles.length || isLoading}
                >
                    {profileCardsComponents}
                </ScrollPaneWithControls>
            </div>
        );
    }
}
